  function createElem(el, options, text) {
  const newElement = document.createElement(el);

  if (options !== undefined) {
    Object.keys(options).forEach((attr) => {
      newElement.setAttribute(attr, options[attr]);
    });
  }

  if (text !== undefined) {
    newElement.innerHTML = text;
  }

  return newElement;
}

function debounce(func){
  let timer;
  return function(event){
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(func, 250, event);
  };
}

function isValidEmail(email) {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; //eslint-disable-line
  return re.test(String(email).toLowerCase());
}

module.exports = { createElem, debounce, isValidEmail };


// WEBPACK FOOTER //
// ./modules/helpers.js